var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-row',{attrs:{"gap":16}},_vm._l((20),function(index){return _c('t-col',{key:index,attrs:{"cols":6,"tablet":6,"mobile":12}},[_c('apps-app-card',{staticClass:"apps-list__card",attrs:{"is-loading":""}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }